import { defineStore } from 'pinia'
import { apiService } from '@/services/api'

export const useTodoMasterStore = defineStore('todoMaster', {
  state: () => ({
    todoMasters: [],
    tableList: [],
    // 元のDBデータをそのまま保持
    formData: null,
    // パース済みのtodoJsonを別に保持
    parsedTodoJson: null,
    formInit: {
      id: null,
      name: '',
      todoJson: null,
    },
    currentCategoryId: null,
  }),
  actions: {
    // テーブル表示用のリストを初期化
    initTableList() {
      this.tableList = [
        { label: 'No', key: 'rowNumber', data: (item, value) => value },
        { label: '種別名', key: 'name', data: (item, value) => value },
      ]
    },

    // テーブル表示用のリストを取得
    async getTodoMasters() {
      try {
        const response = await apiService.get('/api/todo-masters', { hideDialog: true })
        this.todoMasters = response.todoMasters
        return true
      } catch (error) {
        return false
      }
    },

    // ToDoの詳細情報を取得
    async getTodoMasterDetail(id) {
      try {
        const response = await apiService.get(`/api/todo-masters/${id}`)

        // DBのデータをそのまま保持
        this.formData = response.todoMaster

        // todoJsonを別でパースして保持
        this.parseTodoJson()

        return true
      } catch (error) {
        return false
      }
    },

    // todoJsonをパースして別の変数に保持
    parseTodoJson() {
      if (this.formData && this.formData.todoJson) {
        try {
          this.parsedTodoJson = JSON.parse(this.formData.todoJson)
        } catch (error) {
          this.parsedTodoJson = null
        }
      } else {
        this.parsedTodoJson = null
      }
    },

    // 案件マスタを保存（新規作成/更新）
    async saveTodoMaster(todoData) {
      try {
        // 保存用データを準備
        const saveData = {
          id: this.formData.id,
          name: this.formData.name,
          todoJson: JSON.stringify(todoData),
        }

        const response = await apiService.post('/api/todo-masters', saveData)

        // IDを更新（新規作成向けだが、更新時もIDが返ってくる。変わらない場合もある）
        this.formData.id = response.todoMasterId
        return response
      } catch (error) {
        return null
      }
    },

    // 案件マスタを削除
    async deleteTodoMaster(id) {
      try {
        await apiService.delete(`/api/todo-masters/${id}`)

        return true
      } catch (error) {
        return false
      }
    },

    // 保存時にJSONを文字列化
    prepareSaveData() {
      if (this.formData) {
        // 保存用のデータを作成（ディープコピー）
        const saveData = JSON.parse(JSON.stringify(this.formData))

        // parsedTodoJsonがある場合は、それを文字列化してセット
        if (this.parsedTodoJson) {
          saveData.todoJson = JSON.stringify(this.parsedTodoJson)
        }

        return saveData
      }
      return null
    },

    // IDでToDoを検索
    getTodoById(id) {
      return this.todos.find(todo => todo.id === Number(id))
    },

    // 詳細データをクリア
    clearDetailData() {
      this.formData = JSON.parse(JSON.stringify(this.formInit))
      this.parsedTodoJson = null
    },

    // 新規作成やデータ更新時にparsedTodoJsonを更新
    updateParsedTodoJson(newData) {
      this.parsedTodoJson = newData
    },
  },
  getters: {
    // 編集中の案件マスタが新規かどうか
    isNewTodoMaster: state => {
      return !state.formData || !state.formData.id
    },

    // パース済みのtodoJsonを取得
    getTodoJson: state => {
      return state.parsedTodoJson
    },
  },
})
